import { BasicType } from "@easy-email-pro-core/constants";
import { ElementChildren, GroupElement } from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import { isValidReactChildren } from "@easy-email-pro-core/utils/isValidReactChildren";
import React from "react";
import { RecursivePartial } from "@easy-email-pro-core/typings/helper";

export type GroupProps = RecursivePartial<GroupElement["attributes"]> & {
  idx?: string | null;
  children?: ElementChildren | GroupElement["children"];
  data?: GroupElement["data"];
};

export function Group(props: GroupProps) {
  const { data, idx, children: propsChildren, ...rest } = props;

  const node: GroupElement = {
    type: BasicType.GROUP,
    data: data || {},
    attributes: { ...rest },
    children: isValidReactChildren(propsChildren) ? [] : propsChildren || [],
  };

  return (
    <BlockRenderer
      idx={idx}
      node={node}
      children={isValidReactChildren(propsChildren) ? propsChildren : null}
    />
  );
}
